import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Card, EmptyBills } from 'components'
import { useFirebaseEvent, useMobile } from 'hooks'
import { STATICS } from 'statics'
import { fetchInvoices, fetchPaidInvoices } from 'slices/financial'
import { MY_BILLS_PAGE_TAB_LABEL, FIREBASE_EVENTS } from 'app-constants'
import { FinancialLine } from './components'
import './style.scss'

const {
  BANKSLIPS: bankSlipTabLabel,
  INVOICES: invoiceTabLabel,
  PAID: paidTabLabel,
} = MY_BILLS_PAGE_TAB_LABEL

export function MyBills() {
  const { hash } = useLocation()
  const [tab, setTab] = useState(hash.replace('#', ''))
  const { bankSlips, invoices, paid } = useSelector(state => state.financial)
  const {
    selected: { id: idContract },
  } = useSelector(state => state.contract)
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { isMobile } = useMobile()

  useEffect(() => {
    const isInitialPage = invoices.page === 0

    if (isInitialPage) dispatch(fetchInvoices(idContract))
  }, [dispatch, idContract, invoices])

  useEffect(() => {
    if (paid.page === 0) dispatch(fetchPaidInvoices(idContract))
  }, [dispatch, paid.page, idContract])

  function handleSeeMore() {
    dispatch(fetchInvoices(idContract))
  }

  function handleSeeMorePaid() {
    dispatch(fetchPaidInvoices(idContract))
  }

  function handleTabChange(tabLabel, event) {
    setTab(tabLabel)
    if (event) sendEvent(event)
  }

  function renderBankSlips() {
    const { isLoading, error, content } = bankSlips

    if (isLoading) {
      return (
        <div>
          <div className='bills-card-loading' />
        </div>
      )
    }

    if (error) {
      return <EmptyBills billType='Falha ao consultar faturas abertas' />
    }
    if (!!content && content.length === 0) {
      return <EmptyBills billType='Não existem faturas abertas' />
    }

    return content.map(
      (
        {
          value,
          urlFile,
          dueDate,
          id,
          contractId,
          digitableLine,
          qrCode,
          tags,
          isPaymentRecurring,
          detailedInvoiceUrl,
          paymentType,
        },
        index
      ) => (
        <FinancialLine
          index={index}
          key={id}
          id={id}
          value={value}
          urlFile={urlFile}
          dueDate={dueDate}
          contractId={contractId}
          codeBar={digitableLine}
          qrCode={qrCode}
          tags={tags}
          isPaymentRecurring={isPaymentRecurring}
          paymentType={paymentType}
          isMobile={isMobile}
          detailedInvoiceUrl={detailedInvoiceUrl}
        />
      )
    )
  }

  function renderInvoices() {
    const { content, hasMore, error, isLoading } = invoices
    const hasErrorOrEmpty = error || content?.length === 0

    if (isLoading) {
      return (
        <div>
          <div className='bills-card-loading' />
        </div>
      )
    }

    if (hasErrorOrEmpty)
      return <EmptyBills billType='Não existem notas fiscais para esse contrato.' />

    return (
      <>
        {content.map(({ date, id, urlFile, value }, index) => (
          <FinancialLine
            key={id}
            id={id}
            value={value}
            urlFile={urlFile}
            dueDate={date}
            downloadButtonText='Nota fiscal'
            index={index}
            isPaid
            isInvoice
            isMobile={isMobile}
          />
        ))}
        {hasMore && (
          <button type='button' className='button' onClick={handleSeeMore}>
            Ver mais
          </button>
        )}
      </>
    )
  }

  function renderInvoicesPaid() {
    const { content, hasMore } = paid

    let component = null

    if (paid.error) {
      component = <EmptyBills billType='Falha ao consultar faturas pagas' />
    } else if (!!content && content.length === 0) {
      component = <EmptyBills billType='Não existem faturas pagas' />
    } else {
      component = (
        <>
          {content.map(({ id, dueDate, paymentDate, urlFile, value }, index) => (
            <FinancialLine
              key={id}
              id={id}
              value={value}
              urlFile={urlFile}
              dueDate={dueDate}
              paymentDate={paymentDate}
              index={index}
              downloadButtonText='Baixar fatura'
              isPaid
              isMobile={isMobile}
            />
          ))}
          {hasMore && (
            <button type='button' className='button' onClick={handleSeeMorePaid}>
              Ver mais
            </button>
          )}
        </>
      )
    }

    return component
  }

  return (
    <div className='my-bills-page'>
      <Link className='return' to='/'>
        <div className='icon'>
          <STATICS.ARROW_BACK />
        </div>
        VOLTAR
      </Link>
      <h1 className='title'>Minhas faturas</h1>
      <Card className='card'>
        <div className='tabs'>
          <button
            type='button'
            className={`tab ${tab === bankSlipTabLabel ? '-active' : ''}`}
            onClick={() => handleTabChange(bankSlipTabLabel)}
          >
            {bankSlipTabLabel}
          </button>
          <button
            type='button'
            className={`tab ${tab === invoiceTabLabel ? '-active' : ''}`}
            onClick={() => handleTabChange(invoiceTabLabel, FIREBASE_EVENTS.CLICK_ON_INVOICES)}
          >
            {invoiceTabLabel}
          </button>
          <button
            type='button'
            className={`tab ${tab === paidTabLabel ? '-active' : ''}`}
            onClick={() => handleTabChange(paidTabLabel, FIREBASE_EVENTS.CLICK_ON_PAYMENT_HISTORY)}
          >
            {paidTabLabel}
          </button>
        </div>
        {tab === bankSlipTabLabel && renderBankSlips()}
        {tab === invoiceTabLabel && renderInvoices()}
        {tab === paidTabLabel && renderInvoicesPaid()}
      </Card>
    </div>
  )
}
